// removed by extract-text-webpack-plugin
module.exports = {"buttonGroup":"_1HqEkR","buttonGroupSingle":"_31VSYw"};


//////////////////
// WEBPACK FOOTER
// ./src/modules/ButtonGroup/buttonGroup-style.css
// module id = 298
// module chunks = 0